import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import { logGaEvent } from 'common/utils/analytics'
import DropDownFilterBase from '../DropDownFilterBase/DropDownFilterBase'
import style from './UserPreferencesDropDown.less'
import ChevronDown from 'styles/icons/chevron_down.svg'
import { setCookie } from 'common/utils/cookies'
import Flag from 'common/components/chips/Flag'
import responsive from 'common/utils/responsive'
import window from 'global'

import {
  languageMsg,
  currencyMsg,
} from './UserPreferencesDropDown.messages'

const languagesData = [
  {
    label: 'English',
    longLabel: 'English',
    data: 'en',
  },
  {
    label: 'Deutsch',
    longLabel: 'Deutsch',
    data: 'de',
  },
  {
    label: 'Português',
    longLabel: 'Português',
    data: 'pt',
  },
  {
    label: 'Español',
    longLabel: 'Español',
    data: 'es',
  },
  {
    label: 'Français',
    longLabel: 'Français',
    data: 'fr',
  },
  {
    label: 'Italiano',
    longLabel: 'Italiano',
    data: 'it',
  },
  {
    label: 'Русский',
    longLabel: 'Русский',
    data: 'ru',
  },
  {
    label: 'Polski',
    longLabel: 'Polski',
    data: 'pl',
  },
  {
    label: 'Dansk',
    longLabel: 'Dansk',
    data: 'da',
  },
  {
    label: 'Nederlands',
    longLabel: 'Nederlands',
    data: 'nl',
  },
  {
    label: 'Norsk',
    longLabel: 'Norsk',
    data: 'no',
  },
  {
    label: 'Svenska',
    longLabel: 'Svenska',
    data: 'sv',
  },
  {
    label: '日本語',
    longLabel: '日本語',
    data: 'ja',
  },
  {
    label: '한글',
    longLabel: '한글',
    data: 'ko',
  },
  {
    label: 'ไทย',
    longLabel: 'ไทย',
    data: 'th',
  },
  {
    label: '中文简体',
    longLabel: '中文简体',
    data: 'zh',
  },
  {
    label: 'Românește',
    longLabel: 'Românește',
    data: 'ro',
  },
  {
    label: 'Bahasa Melayu',
    longLabel: 'Bahasa Melayu',
    data: 'ms',
  },
  {
    label: 'čeština',
    longLabel: 'čeština',
    data: 'cs',
  },
  {
    label: 'Magyar',
    longLabel: 'Magyar',
    data: 'hu',
  },
  {
    label: 'Ελληνικά',
    longLabel: 'Ελληνικά',
    data: 'el',
  },
  {
    label: 'Suomen kieli',
    longLabel: 'Suomen kieli',
    data: 'fi',
  },
  {
    label: 'Slovenčina',
    longLabel: 'Slovenčina',
    data: 'sk',
  },
  {
    label: 'Hrvatski',
    longLabel: 'Hrvatski',
    data: 'hr',
  }
]

const createListItem = (item, index, currentSelected, labelFunc, callback) => (
  <li
    key={index}
    className={(item.data == currentSelected) ? style.active : null}
    onClick={() => callback(item)}
    data-test={item.label}
  >
    {labelFunc(item)}
  </li>
)

const createListItemLabel = (item) => item.longLabel

const createListItemLabelWithFlag = (item) => (
  <>
    <Flag countryCode={item.data} />
    {item.longLabel}
  </>
)

const LanguageList = (props) => (
  <>
    <span className={style.listTitle}>{languageMsg}</span>
    <ul className={style.singleColumnList} data-test="languageList">
      {props.supportedLanguageCodes.map((languageCode, index) => {
        const language = languagesData.find(item => item.data === languageCode)
        return createListItem(
          language,
          index,
          props.selectedLanguage,
          createListItemLabelWithFlag,
          props.onLanguageClick,
        )
      })}
    </ul>
  </>
)

LanguageList.defaultProps = {
  supportedLanguageCodes: [],
}

LanguageList.propTypes = {
  selectedLanguage: PropTypes.string.isRequired,
  supportedLanguageCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onLanguageClick: PropTypes.func.isRequired,
}

const CurrencyList = (props) => {
  const featuredCurrencies = props.currencyData.filter(
    currency => props.featuredCurrencies.indexOf(currency.data) > -1
  )
  return (
    <>
      <span className={style.listTitle}>{currencyMsg}</span>
      <MediaQuery minWidth={responsive.MEDIA_QUERY_TABLET}>
        <ul className={style.multiColumnList}>
          {featuredCurrencies &&
            featuredCurrencies.map((item, index) =>
              createListItem(
                item,
                index,
                props.selectedCurrency,
                createListItemLabel,
                props.onCurrencyClick,
              )
            )
          }
        </ul>
        <hr />
      </MediaQuery>
      <ul className={style.multiColumnList}>
        {props.currencyData &&
          props.currencyData.map((item, index) =>
            createListItem(
                item,
                index,
                props.selectedCurrency,
                createListItemLabel,
                props.onCurrencyClick,
              )
          )
        }
      </ul>
    </>
  )
}

CurrencyList.propTypes = {
  selectedCurrency: PropTypes.string,
  featuredCurrencies: PropTypes.array.isRequired,
  currencyData: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    longLabel: PropTypes.string.isRequired,
  })),
  onCurrencyClick: PropTypes.func.isRequired,
}

class UserPreferencesDropDown extends DropDownFilterBase {
  onCurrencyClick = (activeItem) => {
    logGaEvent(
      'UserPreferences',
      'Changed:Currency:Header',
      `${this.props.selectedCurrency}>${activeItem.data}`.toLowerCase(),
    )
    this.changeCurrency(activeItem.data)
    this.closeMenu(null)
  }

  changeCurrency = (currencyCode) => {
    this.props.onCurrencyClick(currencyCode)
    setCookie('currency', currencyCode)
    if (window.changeCurrency) {
      window.changeCurrency(currencyCode)
    }
  }

  onLanguageClick = (activeItem) => {
    logGaEvent(
      'UserPreferences',
      'Changed:Language:Header',
      `${this.props.selectedLanguage}>${activeItem.data}`.toLowerCase(),
    )
    this.changeLanguage(activeItem.data)
    this.closeMenu(null)
  }

  changeLanguage = (languageCode) => {
    this.props.onLanguageClick(languageCode)
    setCookie('language', languageCode)
    if (window.changeLanguage) {
      window.changeLanguage(languageCode)
    }
  }

  render() {
    const label = `${this.props.selectedCurrency.toUpperCase()} /
       ${this.props.selectedLanguage.toUpperCase()}`

    return (
      <div className={style.main}>
        <MediaQuery minWidth={responsive.MEDIA_QUERY_TABLET}>
          <div
            className={style.triggerStyle}
            onClick={this.toggleClick}
            data-test="userPrefDropDown"
          >
            <div className={style.label}>
              {label}
            </div>
            <svg viewBox={ChevronDown.viewBox} className={style.downArrow}>
              <use xlinkHref={`#${ChevronDown.id}`} />
            </svg>
          </div>
        {this.state.open &&
          <div className={style.preferenceMenuWrapper} onClick={this.listClick}>
            <div className={style.preferenceMenu}>
              <div className={style.leftCol}>
                <LanguageList
                  selectedLanguage={this.props.selectedLanguage}
                  supportedLanguageCodes={this.props.supportedLanguageCodes}
                  onLanguageClick={this.onLanguageClick}
                />
              </div>
              <div className={style.rightCol}>
                <CurrencyList
                  selectedCurrency={this.props.selectedCurrency}
                  currencyData={this.props.currencyData}
                  featuredCurrencies={this.props.featuredCurrencies}
                  onCurrencyClick={this.onCurrencyClick}
                />
              </div>
            </div>
          </div>
        }
        </MediaQuery>
      </div>
    )
  }
}

UserPreferencesDropDown.propTypes = {
  ...CurrencyList.propTypes,
  ...LanguageList.propTypes,
}

export default UserPreferencesDropDown
